import { render } from "./GridBackground.vue?vue&type=template&id=25e3299b&scoped=true"
import script from "./GridBackground.vue?vue&type=script&lang=js"
export * from "./GridBackground.vue?vue&type=script&lang=js"

import "./GridBackground.vue?vue&type=style&index=0&id=25e3299b&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/eoy-2022-frontend/eoy-2022-frontend/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25e3299b"]])

export default __exports__